import { api } from "../../../Api";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getVendorsThunk = createAsyncThunk('vendor/getVendors', async () => {
    return await api.getVendors()
})

export const vendorBuilder = (builder) => {
    builder.addCase(getVendorsThunk.pending, (state) => {
        state.isLoading = true
        state.vendors = []
    }).addCase(getVendorsThunk.rejected, (state) => {
        state.isLoading = false
        state.error = 'Произошла ошибка при получении кабелей'
        state.vendors = []
    }).addCase(getVendorsThunk.fulfilled, (state, action) => {
        state.isLoading = []
        state.vendors = action.payload
    })
}

